import { render, staticRenderFns } from "./AddOrRemoveEditorDialog.vue?vue&type=template&id=517d8dae"
import script from "./AddOrRemoveEditorDialog.vue?vue&type=script&lang=js"
export * from "./AddOrRemoveEditorDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports